import { render, staticRenderFns } from "./PackingLists.vue?vue&type=template&id=3ae00986"
import script from "./PackingLists.vue?vue&type=script&lang=js"
export * from "./PackingLists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports